import { TemplatePage } from '@/components/layout/TemplatePage'
import html from './template/Faq.html?raw'

export function Faq() {
  return <TemplatePage html={html} />
}
